'use client';

import React from 'react';
import dynamic from 'next/dynamic';
import TermsAndConditionsTemplateStyle from './style';
import { Container, Text } from '@weareconceptstudio/core';
const Editor = dynamic(() => import('@/components/Editor'));

const TermsAndConditionsTemplate = ({ pageData }) => {
	const { content } = pageData;

	const { title, subtitle, overview, descriptions } = content;

	return (
		<TermsAndConditionsTemplateStyle>
			<Container
				row
				className={'terms-and-conditions-container'}>
				<div className='empty-col col-2 col-ds-1 col-dx-12' />

				<div className='empty-col terms-and-conditions-inner-container col-8 col-ds-10 col-dx-12'>
					<div className='inner-container'>
						<Text
							tag='h1'
							className='title h3 black-900 montserrat-400'>
							{title}
						</Text>

						<Text className='subtitle p p1 black-1000 montserrat-500'>{subtitle}</Text>

						<Text className='h4 black-900 montserrat-400 overview-title'>{overview.title}</Text>

						<Text className='p p2 black-850 montserrat-400 overview-description'>{overview.description}</Text>

						{descriptions.length > 0 && (
							<div className='descriptions-wrapper'>
								{descriptions.map(({ title, description }, index) => (
									<div
										key={index}
										className='description-item'>
										<Text className='h5 black-900 montserrat-400 description-title'>{title}</Text>

										<Editor data={description} />
									</div>
								))}
							</div>
						)}
					</div>
				</div>

				<div className='empty-col col-2 col-ds-1 col-dx-12' />
			</Container>
		</TermsAndConditionsTemplateStyle>
	);
};

export default TermsAndConditionsTemplate;
